
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/legal/biometric-data-privacy-policy",
      function () {
        return require("private-next-pages/[lang]/legal/biometric-data-privacy-policy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/legal/biometric-data-privacy-policy"])
      });
    }
  